module.exports = __webpack_public_path__ + "img/crowd_blob_1.a3c66a2c.png";